import { render, staticRenderFns } from "./CapitalProductDetails.vue?vue&type=template&id=35e9be5b&scoped=true"
import script from "./CapitalProductDetails.vue?vue&type=script&lang=js"
export * from "./CapitalProductDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9be5b",
  null
  
)

export default component.exports